import { QueryOptions, useQuery } from '@tanstack/react-query';
import { RQ_LIST_TYPES } from 'Utils';
import { getListTypes } from 'Services';

type Props = {
    runQuery?: boolean;
    queryOptions?: QueryOptions<ListTypes>;
};

function useGetListTypes({ runQuery, queryOptions }: Props) {
    return useQuery([RQ_LIST_TYPES], getListTypes, {
        enabled: runQuery !== false,
        select: (data) => {
            const listNamePairs = data?.types.map((listObj: CustomListObj) => ({
                key: listObj.listType,
                displayValue: listObj.listName,
                systemListType: listObj.systemListType
            }));
            return listNamePairs;
        },
        ...queryOptions
    });
}

export default useGetListTypes;
